import React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import CodeSnippet from '../../../../components/CodeSnippet';

interface IProps {
  powerBiWorkspaceName: string;
  powerBiWorkspaceUrl: string;
}

export const ReportServiceSection = ({
  powerBiWorkspaceName,
  powerBiWorkspaceUrl,
}: IProps) => {
  const handleOpenWorkspace = () => {
    window.open(powerBiWorkspaceUrl, '_blank')?.focus();
  };
  return (
    <SectionWrapper animationIndex={4}>
      <Title>Report service</Title>
      <ContentBlock>
        <Description>CP supports only Power BI service</Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Active service</CostLabel>
            <CodeSnippet>Power BI Workspace</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Workspace name</CostLabel>
            <CodeSnippet>{powerBiWorkspaceName}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Details</CostLabel>
            <CodeSnippet>-</CodeSnippet>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
      <ContentBlock>
        <Description />
        <RightSection>
          <ApButtonMain onClick={handleOpenWorkspace}>
            Open workspace
          </ApButtonMain>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
